"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withAuthHeader = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var withNTLDProvider_1 = require("../withNTLDProvider");
var Header_1 = (0, tslib_1.__importDefault)(require("../components/Header"));
var PariluxDataContext_1 = require("./PariluxDataContext");
var withAuthHeader = function (Component) {
    return (0, withNTLDProvider_1.withNTLDProvider)(function (props) { return (react_1.default.createElement(PariluxDataContext_1.UserPlxDataProvider, null,
        react_1.default.createElement(Header_1.default, null),
        react_1.default.createElement(StyledContainer, null,
            react_1.default.createElement(Component, (0, tslib_1.__assign)({}, props))))); });
};
exports.withAuthHeader = withAuthHeader;
var StyledContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  display: flex;\n  flex-grow: 1;\n  height: 100%;\n  width: 100%;\n  overflow: auto;\n"], ["\n  display: flex;\n  flex-grow: 1;\n  height: 100%;\n  width: 100%;\n  overflow: auto;\n"])));
var templateObject_1;
